// Define a list of events to listen for
const events = ['click'];

// Function to check if a click is outside the element
function onClickOutside({ event, el, handler, middleware }) {
  const isClickOutside = event.target !== el && !el.contains(event.target);

  if (!isClickOutside || !middleware(event, el)) {
    return null;
  }

  return handler(event, el);
}

// Create a Map to store instances
const instances = new Map();

// Function to toggle event listeners for an element
function toggleEventListeners(eventHandlers) {
  return action => {
    eventHandlers.forEach(({ event, handler }) => {
      document[action + 'EventListener'](event, handler, true);
    });
  };
}

// Validator function
function processArgs(value) {
  const isFunction = typeof value === 'function';

  if (!isFunction && typeof value !== 'object') {
    throw new Error(`v-click-outside: Binding value should be a function or an object given`);
  }

  return {
    handler: isFunction ? value : value.handler,
    middleware: value.middleware || (() => true)
  };
}

// Adapter to handle several events for one Map element
function eventAdapter(events, { el, handler, middleware }) {
  return events.map(eventName => ({
    event: eventName,
    handler: event => onClickOutside({ event, el, handler, middleware })
  }));
}

// The custom directive
const clickOutsideDirective = {
  mounted(el, binding) {
    const { handler, middleware } = processArgs(binding.value);
    const eventHandlers = eventAdapter(events, { el, handler, middleware });

    instances.set(el, eventHandlers);

    toggleEventListeners(eventHandlers)('add');
  },

  unmounted(el) {
    const eventHandlers = instances.get(el);

    toggleEventListeners(eventHandlers)('remove');

    instances.delete(el);
  }
};

export default clickOutsideDirective;
